import { Form, FormProps } from "@/components/form";
import { z } from "zod/v4";

export const editVendedorFormSchema = z.object({
    numDocumento: z.string().nonempty("Este campo es requerido"),
    nombre: z.string().nonempty("Este campo es requerido"),
    porcentajeComision: z.number({ message: "Este campo es requerido" }).min(0, "El valor debe ser entre 0 y 100").max(100, "El valor debe ser entre 0 y 100"),
    email: z.string().email(),
    telefono: z.string(),
    direccion: z.string()
})

export default function EditVendedorForm({
    form,
    ...props
}: FormProps<z.infer<typeof editVendedorFormSchema>>) {
    return <Form form={form} gap={3} {...props}>
        <Form.TextField name="numDocumento" label="N° Documento" />
        <Form.TextField name="nombre" label="Nombre" />
        <Form.NumberField name="porcentajeComision" label="Comisión (%)" min={0} max={100} />
        <Form.TextField name="email" label="Email" />
        <Form.TextField name="telefono" label="Telefono" />
        <Form.TextField name="direccion" label="Dirección" />
        <Form.SubmitButton>Guardar</Form.SubmitButton>
    </Form>
}